import { GameState, Investigator } from '../api';

/** Shared turn order, with legacy ownership and lookup fallbacks. */
export const orderedGameInvestigators = (state?: GameState, fallback: Investigator[] = []): Investigator[] => {
  const lookup = new Map<string, Investigator>();
  const add = (value: Investigator) => { if (value?.name) lookup.set(value.name.toLowerCase(), value); };
  fallback.forEach(add);
  Object.values(state?.investigators ?? {}).forEach(add);
  Object.values(state?.investigatorsByName ?? {}).forEach(add);
  const result: Investigator[] = [];
  const seen = new Set<string>();
  const append = (name: string) => {
    const key = name.toLowerCase(), value = lookup.get(key);
    if (value && !seen.has(key)) { seen.add(key); result.push(value); }
  };
  (state?.investigatorTurnOrder ?? []).forEach(append);
  (state?.players ?? []).forEach(player => (player.controlledInvestigators ?? []).forEach(append));
  lookup.forEach(value => append(value.name));
  return result;
};

/** Dock order follows the round's first investigator, independently of the viewer. */
export const orderedDockInvestigators = (state?: GameState, fallback: Investigator[] = []): Investigator[] => {
  const all = orderedGameInvestigators(state, fallback);
  const same = (left?: string | null, right?: string | null) =>
    !!left && !!right && left.toLowerCase() === right.toLowerCase();
  const ordered = all;
  const first = state?.firstInvestigator
    ? ordered.find(value => same(value.name, state.firstInvestigator))
    : ordered.find(value => state?.players?.some(player =>
      same(player.name, state.firstPlayer) && player.controlledInvestigators?.some(name => same(name, value.name))));
  const firstIndex = first ? ordered.indexOf(first) : -1;
  return firstIndex > 0 ? [...ordered.slice(firstIndex), ...ordered.slice(0, firstIndex)] : ordered;
};
